<template>
  <ModalDialog @closeDialog="handleCloseDialog">
    <div class="purpose">
      Change Client OS
    </div>
    <form
      class="basics"
      @submit.prevent="handleOK"
    >
      <div class="formSection">
        <p>By telling Package Manager where you are running R, it can serve packages optimized for your system, and will display any other dependencies you may need.</p>
        <div><label>Select your client operating system</label></div>
        <OSPicker
          v-model="currentOSChoice"
          @change="handleChange"
        />
        <div class="distro-disabled-message">
          {{ disabledMessage(distros) }}
        </div>
      </div>
      <div class="actions">
        <button
          type="submit"
          data-automation="change-os-submit"
        >
          OK
        </button>
      </div>
    </form>
  </ModalDialog>
</template>

<script>

import ModalDialog from './ModalDialog'
import OSPicker from '../OSPicker'
import { mapState } from 'vuex'
import * as types from '../../store/mutation-types'
import { setLocalState, SELECTED_OS } from '../../utils/local-storage'

export default {
  name: 'ChangeOSDialog',
  components: {
    ModalDialog,
    OSPicker,
  },
  data: function () {
    // To make automation easier, we have chosen to use
    // the distro display name as the select option value
    // attribute. This means that we will need to use
    // that text value to locate the selected distro below.
    return {
      currentOS: undefined,
      currentOSChoice: '',
    }
  },
  computed: {
    ...mapState({
      selectedOS: state => state.packages.selectedOS,
      distros: state => state.status.distros,
    }),
  },
  created: function () {
    this.currentOS = this.selectedOS
    this.currentOSChoice = this.selectedOS.display
  },
  methods: {
    handleChange: function (value) {
      // Since our option value is the display name of
      // the distro, we need to iterate over the distros
      // to locate and set the current one.
      this.currentOSChoice = value
      this.currentOS = this.distros.find(element => element.display === value)
    },
    handleOK: function () {
      this.$store.commit(types.SET_SELECTED_OS, this.currentOS)
      setLocalState(SELECTED_OS, this.currentOS)
      this.$emit('closeDialog', null)
    },
    handleCloseDialog: function () {
      this.$emit('closeDialog', null)
    },
    disabledMessage: function (distros) {
      if (!this.currentOS.binaries && this.currentOS.display !== 'macOS') {
        return '*Binary packages have been disabled by your admin for this OS'
      }
      return ''
    },
  },
}

</script>
